export default "__VITE_ASSET__ChtEpYp$__"